import type {
  CommissionStatus,
  InteractionKind,
  PaymentStatus,
  ProspectStatus,
} from "./schema";

export const PROSPECT_STATUS_LABELS: Record<ProspectStatus, string> = {
  a_contacter: "À contacter",
  en_discussion: "En discussion",
  relance: "Relance",
  closed_won: "Closed-won",
  closed_lost: "Closed-lost",
  rembourse: "Remboursé",
};

export type Tone =
  | "navy"
  | "sky"
  | "yellow"
  | "orange"
  | "violet"
  | "coral"
  | "green"
  | "red"
  | "slate";

export const PROSPECT_STATUS_TONE: Record<ProspectStatus, Tone> = {
  a_contacter: "navy",
  en_discussion: "sky",
  relance: "violet",
  closed_won: "green",
  closed_lost: "slate",
  rembourse: "red",
};

export const PROSPECT_STATUS_ORDER: ProspectStatus[] = [
  "a_contacter",
  "en_discussion",
  "relance",
  "closed_won",
  "closed_lost",
  "rembourse",
];

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  due: "À échoir",
  paye: "Payé",
  rembourse: "Remboursé",
};

export const COMMISSION_STATUS_LABELS: Record<CommissionStatus, string> = {
  en_attente_retractation: "Attente rétractation",
  du: "Dû",
  paye: "Payé",
  annule: "Annulé",
};

export const INTERACTION_KIND_LABELS: Record<InteractionKind, string> = {
  note: "Note",
  appel: "Appel",
  message: "Message",
  email: "Email",
  rdv: "RDV",
  relance: "Relance",
};
